module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/290.b9cfa741.png";